import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { ManagedLoginService } from '../managed-login.service';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.css']
})
export class CallbackComponent implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router, private managedLoginService: ManagedLoginService) {}

  
  ngOnInit() {
    this.route.queryParams.subscribe(async params => {
      if (params['code']) {

        await this.managedLoginService.getCognitoToken(params['code'])
        try {
          this.managedLoginService.getCognitoToken(params['code']).subscribe({
            next: (response:any) => {

              if (!response || !response.access_token || !response.id_token) {
                console.error("Respuesta inválida del backend:", response);
                return;
              }
      
              const tokenData = response as { access_token: string; id_token: string; refresh_token: string };

              localStorage.setItem('access_token', tokenData.access_token);
              localStorage.setItem('id_token', tokenData.id_token);
              localStorage.setItem('refresh_token', tokenData.refresh_token);

              this.managedLoginService.scheduleTokenRefresh();

              const userInfo=this.getUserInfo()

              const userGroups = userInfo.cognitoGroups

              if (userGroups.includes('ADMIN_WAREHOUSE') || userGroups.includes('ACCESS_DEV')) {


                localStorage.setItem('email', userInfo.email);
                localStorage.setItem('apellido', userInfo.apellido);
                localStorage.setItem('nombre', userInfo.nombre);
  
                this.router.navigate(['/home']);

              }
              else{
                console.error("Acceso denegado: no pertenece al grupo permitido.");
                this.managedLoginService.signOut();
              }
              
            },
            error: (error) => {
              console.error("Error obteniendo el token:", error);
            }
          });
        } catch (error) {
          console.error("Error en la autenticación:", error);
        }
      }
      
      
    });
  }

  getUserInfo(): any {
    const decodedToken=this.managedLoginService.decodeToken()

    return {
      cognitoGroups:decodedToken['cognito:groups'] || [],
      email: decodedToken.email,
      nombre: decodedToken.middle_name,
      apellido: decodedToken.family_name,
      sub: decodedToken.sub // Identificador único del usuario
    };

}

}
